import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { logout_user, SEND_ALERT } from '@plootus/common';

const useSessionTimeout = (onTimeout, tokenKey = 'jwt_token', timeoutMs = 30 * 60 * 1000) => {
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);

  const handleLogout = async () => {
    if (!localStorage.getItem(tokenKey)) return;

    dispatch({
      type: SEND_ALERT,
      payload: {
        title: 'Session Timeout',
        textContent: 'You have been logged out due to inactivity.',
      },
    });
    
    // Clear all site data
    localStorage.clear();
    
    const clearAllCookies = () => {
      const cookies = document.cookie.split("; ");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        
        const domains = ['', 'app.plootus.com', '.plootus.com', 'www.plootus.com'];
        const paths = ['/', ''];
        
        domains.forEach(domain => {
          paths.forEach(path => {
            let cookieStr = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
            if (path) cookieStr += ` path=${path};`;
            if (domain) cookieStr += ` domain=${domain};`;
            document.cookie = cookieStr;
          });
        });
      }
    };
    
    clearAllCookies();
    
    dispatch(logout_user());
    window.location.href = 'https://plootus.com';
  };

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (!localStorage.getItem(tokenKey)) return;
    
    timeoutRef.current = setTimeout(() => {
      handleLogout();
    }, timeoutMs);
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
    
    const handleActivity = () => resetTimeout();

    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    resetTimeout(); // Initialize timeout

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, []);

  return resetTimeout;
};

export default useSessionTimeout;
